module.exports = __webpack_public_path__ + "img/online-data.841a5130.jpg";